import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { updateConfiguration } from "../../../api/endpoint";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../../../components/loader";

const UpdatePhoneModal = ({ isUpdateOpen, closeUpdateModal, fetchConfig }) => {
  const [phoneNo, setPhoneNo] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false)
  const { config } = useSelector((state) => state.config);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    setPhoneNo(config?.contactInfo?.phoneNo);
  }, [config]);

  const updateConfig = async (e) => {
    e.preventDefault();
    if (!phoneNo) {
      setError("Contact Number Required");
      return;
    } else if (!/^\d{10}(\d{2})?$/.test(phoneNo)) {
      setError("Contact Number should be 10 or 12 digits long")
      return
    }

    const newConfig = {
      ...config,
      contactInfo: {
        ...config?.contactInfo,
        phoneNo: phoneNo,
      },
    };
    try {
      setLoading(true);
      const response = await axios.post(updateConfiguration, newConfig, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      toast.success("Contact Number Updated Successfully");
      closeUpdateModal();
      fetchConfig();
    } catch (error) {
      toast.error("Error Updating Contact Number");
      console.error("Error Updating Contact Number", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {loading && <Loader/>}
    <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Contact Number</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Input
          type="number"
          label="Contact Number"
          placeholder="Enter Contact Number"
          value={phoneNo}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
        {error && <div className="text-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button text="Save Changes" callBack={updateConfig} />
      </Modal.Footer>
    </Modal>
    </>

  );
};

export default UpdatePhoneModal;
